import React, {useState} from "react";
import { Pagination } from "@components";
import { Input,  Select, Radio } from "@components/form";
import {  FormProvider } from 'react-hook-form';
import { useParams} from "react-router-dom";
import { useLectureStudent } from "@hooks";
import { useQueryClient } from '@tanstack/react-query';
import {LectureCfrmModal} from "./LectureCfrmModal";
import {LectureStdtModal} from "./LectureStdtModal";
import LectureTabNav from './LectureTabNav';

const LectureStudent = () => {
  const { lectureId } = useParams();

  const {
    methods, data,
    selectedItems, isAllChecked, onSubmit,
    handlePageChange, handleSelectAll, handleSelectItem, handleDelete, resetSearch,
    pageIndex, recordCountPerPage,
  } = useLectureStudent(lectureId);

  const [formModalOpen, setFormModalOpen] = useState(false);
  const [formModalStdtOpen, setFormModalStdtOpen] = useState(false);
  const queryClient = useQueryClient();

  const handleAddStudent = (e) => {
    e.preventDefault();
    setFormModalStdtOpen(true);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
      alert("수정할 수강생을 한 명 이상 선택하세요.");
      return;
    }
    setFormModalOpen(true);
  };

  const handleModalSuccess = (response) => {
    alert(response.message);
    queryClient.invalidateQueries({ queryKey: ['selectAdminLectureStudentList', lectureId] });
  };


  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="contents-wrap">
        <LectureTabNav lectureId={lectureId} active="student" />
          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
              <div className="search-wrap">
                <div className="search-row">
                  <div className="search-item">
                    <label>조회 조건</label>
                    <Select
                      name="searchCnd"
                      options={[
                        { key: "0", name: "아이디" },
                        { key: "1", name: "이름" },
                        { key: "2", name: "소속회사" },
                      ]}
                      defaultOption="전체"
                      className="input-select"
                    />
                    <Input
                      name="searchWrd"
                      placeholder="검색어를 입력하세요"
                      className="input-search"
                      style={{ width: "300px" }}
                    />

                    <label style={{marginLeft:"20px"}}>신청 여부</label>
                    <Radio name="applyYn" label="전체" value="" />
                    <Radio name="applyYn" label="신청자" value="Y" />
                    <Radio name="applyYn" label="관리자추가" value="N" />
                  </div>
                  <div className="search-btn-container">
                    <button type="submit" className="btn-search">조회</button>
                    <button type="button" className="btn-reset" onClick={resetSearch}>초기화</button>
                  </div>
                </div>
              </div>
                <section className="section-wrap">
                  <div className="section-tit-wrap">
                    <h3 className="border-left-primary">
                      &nbsp;수강생 목록
                      <span className="total-txt">
                        {" "} | 정원 <span className="red">{data?.totalCount}/{data?.studentLimitCnt}</span> 
                      </span>
                    </h3>
                    <div className="btn-right-box">
                      <ul>
                        <li><button title="수정" className="btn-update"  onClick={handleUpdate}>수료정보수정</button></li>
                        <li><button title="등록" className="btn-add"  onClick={handleAddStudent}>수강생추가</button></li>
                        <li><button title="삭제" className="btn-delete" onClick={handleDelete}>수강생삭제</button></li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-container">
                    <div className="table-box">
                    <table className="table-list" style={{width:"100%"}}>
                      <colgroup>
                        <col style={{ width: "1%" }} />
                        <col style={{ width: "3%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "7%" }} />
                        <col style={{ width: "10%" }} />
                        {/* <col style={{ width: "7%" }} /> */}
                        {/* <col style={{ width: "10%" }} /> */}
                        <col style={{ width: "3%" }} />
                        <col style={{ width: "3%" }} />
                        <col style={{ width: "3%" }} />
                        <col style={{ width: "5%" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th> <input type="checkbox" checked={isAllChecked} onChange={handleSelectAll} /> </th>
                          <th>번호</th>
                          <th>아이디</th>
                          <th>이름</th>
                          <th>생년월일</th>
                          <th>이메일</th>
                          <th>전화번호</th>
                          <th>소속회사</th>
                          {/* <th>세금계산서담당자</th> */}
                          {/* <th>담당자이메일</th> */}
                          <th>수강기간</th>
                          <th>수료시간</th>
                          <th>수료여부</th>
                          <th>신청여부</th>
                        </tr>
                      </thead>
                      <tbody>
                      {data?.resultList && data.resultList.length > 0 ? (
                        data.resultList.map((item, idx) => (
                          <tr 
                              key={item.memberId}
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSelectItem(item.memberId)
                              }}
                          >
                            <td onClick={(e) => e.stopPropagation()}>
                              <input 
                                type="checkbox" 
                                checked={selectedItems.includes(item.memberId)} 
                                onChange={(e) => {
                                  e.stopPropagation();
                                  handleSelectItem(item.memberId)
                                }} />
                            </td>
                            <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                            <td style={{textAlign:"left"}}>{item.memberId}</td>
                            <td>{item.memberNm}</td>
                            <td>{item.birthDt}</td>
                            <td style={{textAlign:"left"}}>{item.email}</td>
                            <td>{item.phoneNo}</td>
                            <td>{item.companyNm}</td>
                            {/* <td>{item.taxMgrNm}</td> */}
                            {/* <td>{item.taxMgrEmail}</td> */}
                            <td>{item.comdName}</td>
                            <td>{item.completeTime ? `${item.completeTime}시간` : '-'}</td>
                            <td>{item.completeYn === 'Y' ? '수료' : '미수료'}</td>
                            <td>
                              <span
                                className="red"
                                style={{ fontWeight: item.applyYn === 'Y' ? 'bold' : 'normal' }}
                              >
                                {item.applyYn === 'Y' ? '신청자' : '관리자추가'}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={11} style={{ textAlign: 'center' }}>
                            조회 결과가 없습니다.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    </table>
                    </div>
                  </div>
                    {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                    <Pagination
                        totalPages={Math.ceil(
                          data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                        )}
                        currentPage={pageIndex}
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={10}
                    />
                    )}
                </section>
            </div>
          </div>
        </div>
      </form>
      <LectureCfrmModal
        isOpen={formModalOpen}
        onClose={() => setFormModalOpen(false)}
        selectedItems={selectedItems}
        lectureId={lectureId}
        onSuccess={handleModalSuccess}
      />
      <LectureStdtModal
        isOpen={formModalStdtOpen}
        onClose={() => setFormModalStdtOpen(false)}
        lectureId={lectureId}
        onSuccess={handleModalSuccess}
      />
    </FormProvider>
    
  );
};

export {LectureStudent};
